import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

export function useUserRole() {
  const currentUserRole = useMapGetter('getCurrentRole');
  const currentUser = useMapGetter('getCurrentUser');

  const isAdmin = computed(() => currentUserRole.value === 'administrator');
  const isManager = computed(() => currentUserRole.value === 'manager');
  const isAgent = computed(() => currentUserRole.value === 'agent');

  return {
    currentUserRole,
    currentUser,
    isAdmin,
    isManager,
    isAgent,
  };
}
